import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import { decodeId, encodeId } from "../../../../../../utils/hash";
import { Link, useParams } from "react-router-dom";
import EADetailsCard from "../../components/EADetailsCard";
import { EALinkListData } from "../../../../network/api/EALinkListData";
import PaginationSmall from "../../../../../../components/PaginationSmall";
import LinkItemsCard from "./components/ClientsTabCard";
import Alerts from "../../../../../../components/Alerts";
import { EALinkData } from "../../../../network/api/EALinkData";


export default function EALink() {
    const { setPageTitle } = useAppContext();
    const { id: eaID } = useParams();
    const eaId = decodeId(eaID);

    const [expert, setExpert] = useState(false);
    const [eaLinkList, setEALinkList] = useState([]);
    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: [],
    });

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const [pageFilters, setPageFilters] = useState({
        page: null,
        host_ea_id: eaId,
        client_ea_id: null,
        status: null,
    });

    const [tab, setTab] = useState("clients");
    const handleTabChange = (newTab) => {
        if (newTab !== "requests") {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                status: null,
                host_ea_id: newTab === "clients" ? eaId : null,
                client_ea_id: newTab === "hosts" ? eaId : null,
            }));
        }
        setTab(newTab);
    }

    const [linkCode, setLinkCode] = useState("");
    const [confirmLink, setConfirmLink] = useState(false);

    const handleSendRequest = async () => {
        if (!linkCode || !confirmLink) return;
        try {
            setIsLoading(true);
            setErrorMessage(null);
            const response = await EALinkData({ method: "POST", formData: { host_ea_code: linkCode, client_ea_code: expert?.secret_code } });
            if (response.status === "success") {
                setErrorMessage({ status: "success", message: response.message });
            } else {
                setErrorMessage({ status: "danger", message: response.message });
            }
        } catch (error) {
            setErrorMessage({ status: "danger", message: error.message });
        } finally {
            setLinkCode("");
            setConfirmLink(false);
            setIsLoading(false);
        }


    };


    useEffect(() => {
        const fetchEALinkListData = async () => {
            setIsLoading(true);
            setErrorMessage(null);
            const response = await EALinkListData({ pageFilters });
            if (response.status === "success") {

                setPageProps({
                    page: response.data.page,
                    totalPages: response.data.total_pages,
                    totalEntries: response.data.total_records,
                    entryLimit: response.data.limit,
                    visiblePages: response.data.visible_pages,
                })
                setEALinkList(response.data.data);
            } else {
                setErrorMessage({ status: "danger", message: response.message });
            }
            setIsLoading(false);
        };
        fetchEALinkListData();
    }, [pageFilters]);


    useEffect(() => {
        setPageTitle("EA Link");

        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(el => new window.bootstrap.Tooltip(el));
    }, [setPageTitle]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row page-titles">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to={`/eas/${encodeId(eaId)}`}>EA Details</Link></li>
                            <li className="breadcrumb-item active"><span>EA Link</span></li>
                        </ol>
                    </div>

                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="card custom-card">
                                <div className="card-body">

                                    {!isLoading && errorMessage ?
                                        <Alerts type={errorMessage.status === "success" ? "success" : "danger"} message={errorMessage.message} />
                                        : <></>}
                                    {/* Updated Bootstrap Nav-Pills Structure */}
                                    <ul className="nav nav-pills mb-4 light" id="ea-link-pills" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className={tab === "clients" ? "nav-link active" : "nav-link"} onClick={() => handleTabChange("clients")} data-bs-toggle="pill" data-bs-target="#navpills-1" type="button" role="tab" aria-controls="navpills-1" aria-selected={tab === "clients"}>
                                                Clients Linked To Me
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className={tab === "hosts" ? "nav-link active" : "nav-link"} onClick={() => handleTabChange("hosts")} data-bs-toggle="pill" data-bs-target="#navpills-2" type="button" role="tab" aria-controls="navpills-2" aria-selected={tab === "hosts"}>
                                                My Host EA Links
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className={tab === "requests" ? "nav-link active" : "nav-link"} onClick={() => handleTabChange("requests")} data-bs-toggle="pill" data-bs-target="#navpills-3" type="button" role="tab" aria-controls="navpills-3" aria-selected={tab === "requests"}>
                                                Send Link Request
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className={`tab-pane fade ${tab === "clients" ? "show active" : ""}`} id="navpills-1" role="tabpanel">
                                            <h5 className="mb-3">Clients Linked To Me</h5>
                                            {isLoading ? (
                                                <div className="text-center py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <LinkItemsCard items={eaLinkList} tab={tab} setEALinkList={setEALinkList} setErrorMessage={setErrorMessage} setIsLoading={setIsLoading} />
                                            )}
                                        </div>

                                        <div className={`tab-pane fade ${tab === "hosts" ? "show active" : ""}`} id="navpills-2" role="tabpanel">
                                            <h5 className="mb-3">My Host EA Links</h5>
                                            {isLoading ? (
                                                <div className="text-center py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <LinkItemsCard items={eaLinkList} tab={tab} setEALinkList={setEALinkList} setErrorMessage={setErrorMessage} setIsLoading={setIsLoading} />
                                            )}
                                        </div>

                                        <div className={`tab-pane fade ${tab === "requests" ? "show active" : ""}`} id="navpills-3" role="tabpanel">
                                            <h5 className="mb-3">Send Link Request</h5>
                                            <p className="text-muted">
                                                You are about to connect your EA <strong>{expert?.name || "..."}</strong> to another one by providing its EA code below.
                                            </p>


                                            {isLoading ? (
                                                <div className="text-center py-5">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <form className="mb-3" onSubmit={(e) => e.preventDefault()}>
                                                    <div className="row g-2 align-items-center">
                                                        <div className="col-md-9">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter EA secret code"
                                                                value={linkCode}
                                                                onChange={(e) => setLinkCode(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-3 d-grid">
                                                            <button
                                                                className="btn btn-primary"
                                                                type="button"
                                                                onClick={handleSendRequest}
                                                                disabled={!linkCode || !confirmLink}
                                                            >
                                                                Send Request
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="form-check mt-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="confirmLink"
                                                            checked={confirmLink}
                                                            onChange={(e) => setConfirmLink(e.target.checked)}
                                                        />
                                                        <label className="form-check-label" htmlFor="confirmLink">
                                                            I confirm I want to link to this EA.
                                                        </label>
                                                    </div>
                                                </form>
                                            )}
                                        </div>
                                    </div>
                                    {tab !== "requests" && (
                                        <PaginationSmall pageProps={pageProps} onPageChange={(page) => setPageFilters((prev) => ({ ...prev, page }))} />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div>
                                <EADetailsCard eaId={eaId} setExpert={setExpert} expert={expert} showImage={true} showFooterStats={false} showGButton={true} />

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}